export const useAuthStore = defineStore('authStore', () => {
  const idToken = ref<string>('');
  const isReady = ref(false);
  
  const setIdToken = ( token: string) => {
    idToken.value = token;
  };

  const clearIdToken = () => {
    idToken.value = '';
  };

  const setReady = (ready: boolean) => {
    isReady.value = ready;
  };

  return {
    idToken,
    isReady,
    setIdToken,
    clearIdToken,
    setReady
  };
});